import __request__ from "routing/request";
export function list(sort = "name", page = 1, per_page = 15, query, direction = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/sigma/repositories", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(CreateRepoRequest, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/sigma/repositories", CreateRepoRequest, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkDeleteRepos(RepositoryIDs, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/sigma/repositories/bulk/delete", RepositoryIDs, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createDefault(requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/sigma/repositories/default", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function importAll(ImportAllRulesRequest, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp/sigma/repositories/import_all", ImportAllRulesRequest, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function refreshRepo(id, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/sigma/repositories/refresh/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getRulesFromRepo(id, path, query, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp/sigma/repositories/${id}`, null, { "path": path, "query": query }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateRepo(id, UpdateRepoRequest, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/sigma/repositories/${id}`, UpdateRepoRequest, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteRepo(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp/sigma/repositories/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
